import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorProductPriceDiscountSearch = () => {
  const priceDiscountSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/product/price-discount/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { priceDiscountSearch }
}

export default InteractorProductPriceDiscountSearch
